import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LOGO_URL } from '../../data/mock';

export const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleAnchorClick = (e, href) => {
    e.preventDefault();
    const [path, hash] = href.split('#');
    if (location.pathname !== '/' && path === '/') {
      navigate('/', { state: { scrollTo: hash } });
    } else if (hash) {
      const el = document.getElementById(hash);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-vine-primary text-vine-neutral/60">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="w-full h-px bg-copper/20" />

        <div className="py-20">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
            {/* Column 1 — Brand */}
            <div>
              <img src={LOGO_URL} alt="Copper & Vine" className="h-10 w-auto mb-5" />
              <p className="text-[14px] text-vine-neutral/50 leading-relaxed">
                Copper &amp; Vine Studio
              </p>
              <p className="text-[14px] text-vine-neutral/40">
                Advisory Circle &middot; Washington DC &amp; Global
              </p>
            </div>

            {/* Column 2 — Navigation */}
            <div>
              <h4 className="text-[11px] tracking-[0.2em] uppercase text-copper mb-5 font-body font-medium">Navigation</h4>
              <div className="flex flex-col gap-3">
                <a href="/#membership" onClick={(e) => handleAnchorClick(e, '/#membership')} className="text-[14px] hover:text-copper transition-colors duration-300">Membership</a>
                <a href="/#the-table" onClick={(e) => handleAnchorClick(e, '/#the-table')} className="text-[14px] hover:text-copper transition-colors duration-300">The Table</a>
                <a href="/#who" onClick={(e) => handleAnchorClick(e, '/#who')} className="text-[14px] hover:text-copper transition-colors duration-300">Who It&rsquo;s For</a>
                <Link to="/apply" className="text-[14px] hover:text-copper transition-colors duration-300">Apply</Link>
                <a href="https://coppervine.io" target="_blank" rel="noopener noreferrer" className="text-[14px] hover:text-copper transition-colors duration-300">
                  Copper &amp; Vine Studio &rarr;
                </a>
              </div>
              <h4 className="text-[11px] tracking-[0.2em] uppercase text-copper mt-8 mb-4 font-body font-medium">Organizations</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/for-organizations" className="text-[13px] hover:text-copper transition-colors">For Organizations</Link>
                <Link to="/for-organizations/venture-capital" className="text-[13px] text-vine-neutral/40 hover:text-copper transition-colors">&rarr; Venture Capital</Link>
                <Link to="/for-organizations/accelerators" className="text-[13px] text-vine-neutral/40 hover:text-copper transition-colors">&rarr; Accelerators</Link>
                <Link to="/for-organizations/communities" className="text-[13px] text-vine-neutral/40 hover:text-copper transition-colors">&rarr; Community Organizations</Link>
                <Link to="/for-organizations/cohorts" className="text-[13px] text-vine-neutral/40 hover:text-copper transition-colors">&rarr; Fellowship &amp; Cohort Programs</Link>
              </div>
            </div>

            {/* Column 3 — Legal / Identity */}
            <div>
              <h4 className="text-[11px] tracking-[0.2em] uppercase text-copper mb-5 font-body font-medium">Legal</h4>
              <div className="flex flex-col gap-3">
                <p className="text-[14px] text-vine-neutral/45">
                  &copy; 2026 Copper &amp; Vine Studio, Co.
                </p>
                <p className="text-[14px] text-vine-neutral/40">
                  Minority &amp; Woman Owned Business
                </p>
                <p className="text-[14px] text-vine-neutral/40">
                  Washington DC
                </p>
                <p className="text-[13px] text-vine-neutral/30 italic mt-3">
                  Operate better. Not louder.
                </p>
              </div>
            </div>
          </div>

          {/* Institutional CTA */}
          <div className="mt-12 pt-8 border-t border-white/[0.05]">
            <p className="text-vine-neutral/40 text-[14px]">
              Bringing the Advisory Circle to your portfolio, cohort, or community?{' '}
              <Link to="/for-organizations" className="text-copper/60 hover:text-copper transition-colors">Start the Conversation &rarr;</Link>
            </p>
          </div>

          {/* Global statement */}
          <div className="mt-8 pt-6 border-t border-white/[0.04]">
            <p className="text-vine-neutral/30 text-[12px] leading-relaxed">
              The Advisory Circle has operated since Copper &amp; Vine&rsquo;s founding. This is the first time it&rsquo;s been formally opened. Membership is limited and application-gated.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
